import { render } from "./CreateRozetkaWaybillModal.vue?vue&type=template&id=0320ee25"
import script from "./CreateRozetkaWaybillModal.vue?vue&type=script&lang=js"
export * from "./CreateRozetkaWaybillModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__